export enum BookingType {
  Flight = "Flight",
  Ground = "Ground",
  Lodging = "Lodging",
  Package = "Package",
  Activities = "Activities",
  Homes = "Homes",
}

export enum FlightExchangeModalState {
  ContactAirline,
  ContactSupport,
  IneligibleForExchange,
  LoadFailed,
  Loading,
  TicketedVoidable,
}
